export default function Footer(props) {

  return <section className="text-align-center disclaimer" style={{paddingBottom:'24px'}}>
    <div className={'flex flex-gapped flex-align-center flex-align-middle'}>
      <a target="_hrx_t" href={props.config.disclaimers.privacy}>Privacy Policy</a>
      <a target="_hrx_t" href={props.config.disclaimers.terms}>Terms & Condition</a>
    </div>
  </section>

}